.HiddenPalette {
    display: none;
}

.ClearBoth {
    clear: both;
    height: 0px;
    font-size: 0px;
}

:host div.OpportunityEmptyNotice {
    font-size: 1.20em;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
    text-transform: capitalize;
    text-align: center;
}

:host div#SSPBCardList {
    padding: 0px 10px 20px 0px;
    align-items: center;
}

:host div#SSPBFooter {
    text-align: center;
    margin-bottom: 20px;
}

:host div#SSPBFooter p {
    font-size: 0.8em;
    margin: 0px;
}

:host opportunity-card {
    float: left;
    margin-left: 10px;
    margin-bottom: 10px;
}

:host opportunity-card:first-of-type {
    margin-left: 10px;
    margin-bottom: 0px;
}

:host opportunity-card:last-of-type {
    margin-bottom: 0px;
}

:host div#PaginationPalette {
    text-align: center;
    margin: 0px 10px 20px 10px;
    text-transform: uppercase;
    font-size: 0.9em;
}

:host div#PaginationPalette div.PaginationStatus {
    margin-top: 13px;
}

:host div#PaginationPalette ion-grid {
    width: 400px;
}

:host div#PaginationPalette ion-button {
    --color: black
}
